import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, alpha } from '@material-ui/core';
import Box from '@material-ui/core/Box';

const ScalesIllustration = ({ size = 220 }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  return (
    <Box
      component="svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      aria-hidden
      sx={{ display: 'block', mx: 'auto' }}
    >
      <defs>
        <linearGradient id="scales-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={primary} />
          <stop offset="100%" stopColor={secondary} />
        </linearGradient>
      </defs>
      <circle cx="100" cy="100" r="92" fill={alpha(primary, 0.06)} />
      <circle cx="100" cy="100" r="72" fill={alpha(secondary, 0.08)} stroke={alpha(primary, 0.12)} strokeWidth="1.5" />
      <rect x="96" y="48" width="8" height="72" rx="3" fill="url(#scales-grad)" />
      <rect x="72" y="48" width="56" height="6" rx="3" fill="url(#scales-grad)" />
      <line x1="100" y1="54" x2="100" y2="44" stroke={primary} strokeWidth="3" strokeLinecap="round" />
      <circle cx="100" cy="40" r="5" fill={secondary} />
      <path
        d="M58 78 C58 92 48 98 48 108 C48 118 68 118 68 108 C68 98 58 92 58 78 Z"
        fill={alpha(primary, 0.18)}
        stroke={primary}
        strokeWidth="2"
      />
      <path
        d="M142 78 C142 92 152 98 152 108 C152 118 132 118 132 108 C132 98 142 92 142 78 Z"
        fill={alpha(secondary, 0.18)}
        stroke={secondary}
        strokeWidth="2"
      />
      <line x1="68" y1="78" x2="68" y2="54" stroke={primary} strokeWidth="2" />
      <line x1="132" y1="78" x2="132" y2="54" stroke={secondary} strokeWidth="2" />
      <rect x="82" y="120" width="36" height="8" rx="2" fill={alpha(primary, 0.35)} />
      <rect x="88" y="128" width="24" height="28" rx="3" fill="url(#scales-grad)" opacity="0.85" />
    </Box>
  );
};

ScalesIllustration.propTypes = {
  size: PropTypes.number,
};

export default ScalesIllustration;
